import { Card, Form, message } from 'antd';
import RegistrationForm from '../../components/monaliza/authentication/RegistrationForm';
import { useDispatch } from 'react-redux';
import { loginAsync, registerAsync } from '../../app/store/reducers/auth/authReducer';



const Registration = () => {
  const dispatch = useDispatch()
    const [messageApi, contextHolder] = message.useMessage();


    

    const success = () => {
    messageApi.open({
      type: 'success',
      content: 'This is a success message',
    });
  };

  const error = () => {
    messageApi.open({
      type: 'error',
      content: 'This is an error message',
    });
  };



  const onFinish = (values) => {
    console.log(values);
    // dispatch(registerAsync({
    //   name: values?.name,
    //   email: values?.email,
    //   password: values?.password, 
    //   confirmPassword: values?.confirm,
    // }))
    registerAsync({
      name: values?.name,
      email: values?.email,
      password: values?.password, 
      confirmPassword: values?.confirm,
    })
      .then(() => {
        success()
            dispatch(loginAsync({email: values?.email, password: values?.password}))
      })
      .catch((err) => {
        error()
      })
  }
  


    return (
    <>
    {contextHolder}
      <Form
      name="register"
      onFinish={onFinish}
      initialValues={{}}
      scrollToFirstError
      style={{
        width: "550px"
      }}
    >
        <Card>
            <RegistrationForm/>
        </Card>
      </Form>
    </>
  )
}

export default Registration